import { IS_DEV, IS_PROD } from './constants.helper';

const nativeConsole = {
  log: console.log.bind(console),
  debug: console.debug.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

function sendToLogService(_level, _args) {
  // TODO: send to a log service if/when available
  // Example:
  // Sentry.captureException(...)
  // Datadog.logger.error(...)
}

const logger = {
  log: (...args) => {
    if (IS_DEV) {
      nativeConsole.log(...args);
    }

    if (IS_PROD) {
      // Optional: sendToLogService('log', args);
    }
  },

  debug: (...args) => {
    if (IS_DEV) {
      nativeConsole.debug(...args);
    }

    if (IS_PROD) {
      // Usually ignored in production
    }
  },

  info: (...args) => {
    if (IS_DEV) {
      nativeConsole.info(...args);
    }

    if (IS_PROD) {
      // Optional: sendToLogService('info', args);
    }
  },

  warn: (...args) => {
    if (IS_DEV) {
      nativeConsole.warn(...args);
    }

    if (IS_PROD) {
      // Optional: sendToLogService('warn', args);
    }
  },

  error: (...args) => {
    if (IS_DEV) {
      nativeConsole.error(...args);
    }

    if (IS_PROD) {
      sendToLogService('error', args);
    }
  },
};

let isConsoleRedirectInstalled = false;

export function installConsoleRedirect() {
  if (isConsoleRedirectInstalled) return;

  isConsoleRedirectInstalled = true;

  console.log = (...args) => {
    logger.log(...args);
  };

  console.debug = (...args) => {
    logger.debug(...args);
  };

  console.info = (...args) => {
    logger.info(...args);
  };

  console.warn = (...args) => {
    logger.warn(...args);
  };

  console.error = (...args) => {
    logger.error(...args);
  };
}

export function installGlobalErrorHandlers() {
  window.addEventListener('error', (event) => {
    logger.error('Uncaught error:', event.error || event.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    logger.error('Unhandled promise rejection:', event.reason);
  });
}

export { nativeConsole };

export default logger;
